import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Divider } from 'antd';
import React from 'react';
import AreaCreateModal from '../AreaCreateModal';
import { useDisclosure } from '@/hooks';

interface Props {
  disabled: boolean;
}

const AreaFooter: React.FC<Props> = ({ disabled }) => {
  const [modalCreateAreaOpen, modalCreateAreaActions] = useDisclosure();

  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/operational/areas" disabled={disabled} />

        <Button
          block
          type="primary"
          onClick={modalCreateAreaActions.open}
          disabled={!hasPermissions([Authorities.REGISTER_AREA_ADD])}
        >
          Nova área
        </Button>
      </SpaceForButton>

      <AreaCreateModal
        onCancel={modalCreateAreaActions.close}
        open={modalCreateAreaOpen}
      />
    </>
  );
};

export default AreaFooter;
